export default function (chart, divId, vizName, resData) {
    const container =
        typeof divId === "string"
            ? document.getElementById(divId)
            : divId;

    if (!container) {
        console.error("Container not found", divId);
        return;
    }

    // ✅ container styling (row layout)
    container.innerHTML = "";
    container.style.display = "flex";
    container.style.flexWrap = "wrap";
    container.style.gap = "24px";
    container.style.padding = "16px";
    container.style.alignItems = "stretch";
    container.style.boxSizing = "border-box";
    container.style.justifyContent = "center"

    // Add responsive CSS class to container
    container.classList.add("responsive-cards-container");

    resData.forEach(item => {
        const card = document.createElement("div");

        // ✅ Responsive card styling using CSS properties
        card.style.flex = "1 1 200px"; // flex-grow, flex-shrink, flex-basis
        card.style.minWidth = "200px";
        card.style.maxWidth = "300px";
        card.style.background = "#fff";
        card.style.borderRadius = "8px";
        card.style.padding = "20px 24px";
        card.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)";
        card.style.display = "flex";
        card.style.flexDirection = "column";
        card.style.justifyContent = "center";
        card.style.boxSizing = "border-box";

        // Responsive font sizes
        const titleStyle = `
            font-size: min(max(16px, 2vw), 20px);
            margin-bottom: 8px;
            word-break: break-word;
        `;
        const valueStyle = `
            font-size: min(max(22px, 3vw), 28px);
            font-weight: 600;
            color: #111827;
        `;

        card.innerHTML = `
            <div style="${titleStyle}">
                ${item.dim1_name}
            </div>
            <div style="${valueStyle}">
                ${item.metric1}
            </div>
        `;

        container.appendChild(card);
    });

    // Add responsive breakpoint adjustments
    const checkResponsive = () => {
        const width = container.offsetWidth;
        const cards = container.querySelectorAll('div[style*="flex"]');

        cards.forEach(card => {
            if (width < 768) {
                card.style.flex = "1 1 calc(50% - 12px)";
                card.style.minWidth = "calc(50% - 12px)";
                card.style.maxWidth = "calc(50% - 12px)";
            } else if (width < 480) {
                card.style.flex = "1 1 100%";
                card.style.minWidth = "100%";
                card.style.maxWidth = "100%";
            } else {
                card.style.flex = "1 1 200px";
                card.style.minWidth = "200px";
                card.style.maxWidth = "300px";
            }
        });
    };

    // Check on load and resize
    checkResponsive();
    window.addEventListener('resize', checkResponsive);
}